import React from 'react';
import PropTypes from 'prop-types';
import { Confirm } from 'react-confirm-bootstrap';
import { MenuItem } from 'react-bootstrap/lib';
import { Permissions } from '@upstart/harmony/lib/constants';
import { isUserLockedOut } from '@upstart/harmony/lib/user-utils';
import withUserPermission from './userPermission';

function UnlockButton({ user, onUnlock }) {
  // if the user is not locked out then don't render the unlock account button
  if (!isUserLockedOut(user)) {
    return null;
  }

  return (
    <Confirm
      onConfirm={() => {
        onUnlock(user.id);
      }}
      body={`Account locked from too many failed login attempts.  Are you sure you want to unlock ${user.firstName} ${user.lastName}?`}
      confirmText="Confirm Unlock"
      title={`Unlocking ${user.firstName} ${user.lastName}`}
      confirmBSStyle="primary"
    >
      <MenuItem>Unlock Account</MenuItem>
    </Confirm>
  );
}

UnlockButton.propTypes = {
  user: PropTypes.object,
  onUnlock: PropTypes.func,
};

export default withUserPermission(Permissions.UPDATE)(UnlockButton);
